<template>
<div>
  <section class="hero is-primary" id="head-section">
    <div class="hero-body">
      <div class="container has-text-centered">
        <h2 class="title">平差计算</h2>
      </div>
    </div>
  </section>

<div class="card">
  <header class="card-header">
    <p class="card-header-title">
      原始观测数据
    </p>
  </header>
  <div class="card-content">
    <div v-for="listKey in Object.keys(fileList)" :key="listKey">
      <div v-if="listKey !== 'fileList1'" style="margin-top: 10px;"></div>
      <div class="file has-name">
        <label class="file-label">
          <input class="file-input" type="file" @change="previewFile(listKey, $event)" multiple="multiple">
          <span class="file-cta">
            <span class="file-icon">
              <i class="fas fa-upload"></i>
            </span>
            <span class="file-label">
              选择 .dat 文件…
            </span>
          </span>
          <span class="file-name">
            <i v-if="fileList[listKey].length === 0" style="color:gray">&lt;未选择文件&gt;</i>
            <p v-else>{{ fileList[listKey].length }}个文件</p>
          </span>
        </label>
      </div>
      <span v-if="fileList[listKey].length != 0">
        <p class="addition-text">
          <span v-for="(item, index) in fileList[listKey]" :key="item.name">
            <span v-if="index === 0">{{ item.name }}</span>
            <span v-else>、{{ item.name }}</span>
          </span>
        </p>
      </span>
    </div>

    <p class="buttons" v-if="isWxAndroidClient" style="margin-top: 10px;">
      <button class="button" @click="changeUploadNumber(true)">
        <span class="icon">
          <i class="fas fa-plus"></i>
        </span>
      </button>
      <button class="button" v-if="uploadNumber > 1" @click="changeUploadNumber(false)">
        <span class="icon">
          <i class="fas fa-minus"></i>
        </span>
      </button>
    </p>
  </div>

  <div class="card-footer">
    <button
      class="card-footer-item is-primary"
      :disabled="!isFillComplete"
      @click="submitDiniDat"
    >
      提交
    </button>
  </div>
</div>

<nav class="panel" v-show="isShowPanel">
  <p class="panel-heading">数据查看和编辑</p>
  <!-- <div class="panel-block">
    <p class="control has-icons-left">
      <input class="input" type="text" placeholder="搜索">
      <span class="icon is-left">
        <i class="fas fa-serach" aria-hidden="true"></i>
      </span>
    </p>
  </div> -->
  <p class="panel-tabs">
    <a :class="{ 'is-active': panelTabIndex == 1 }"
       @click="tabClick(1)">
      测点列表
    </a>
    <a :class="{ 'is-active': panelTabIndex == 0 }"
       @click="tabClick(0)">
      高差列表
    </a>
  </p>
  <div class="panel-block">
    <!-- datatable for 测点列表 -->
    <data-table class="center"
                v-show="panelTabIndex == 1"
                :columns="columnsPoint"
                :rows="rowsPoint"
                :click="true"
                tableClass="table is-striped is-bordered is-narrow"
                @row-click="(val) => rowClick(val)">
      <template slot="table-body" slot-scope="props">
        <td>{{ props.row.pointname}}</td>
        <td class="has-text-right">{{ props.row.h.toFixed(5) }}</td>
        <td class="has-text-centered">{{ props.row.isVKnown == 1 ? "&#10003;" : "" }}</td>
      </template>
    </data-table>
    <!-- datatable for 高差列表 -->
    <data-table class="center"
                v-show="panelTabIndex == 0"
                :columns="columnsDetaH"
                :rows="rowsDetaH"
                tableClass="table is-striped is-bordered is-narrow">
      <template slot="table-body" slot-scope="props">
        <td>{{ props.row.pointFrom }}</td>
        <td>{{ props.row.pointTo }}</td>
        <!-- <td class="has-text-right">{{ Math.round(props.row.detaH * 100000)/100000 }}</td>
        <td class="has-text-right">{{ Math.round(props.row.dist * 1000)/1000 }}</td> -->
        <td class="has-text-right">{{ props.row.detaH.toFixed(5) }}</td>
        <td class="has-text-right">{{ props.row.dist.toFixed(3) }}</td>
      </template>
    </data-table>
  </div>
</nav>

<div v-show="isShowPanel">
<div class="card">
  <header class="card-header">
    <p class="card-header-title">
      精度指标
    </p>
  </header>
  <div class="card-content">

<nav class="level">
  <div class="level-item has-text-centered">
    <div class="field has-addons">

    <p class="control">
      <span class="button is-static"><span style="color:black;">测量等级</span></span>
    </p> <!-- control (end) -->
    <p class="control">
      <label class="select">
        <select v-model.number="precisionGradeCode" @change="onPrecisionGradeChanged">
          <option style="display:none" value=-1> -- 请选择 -- </option>
          <option v-for="item in itemsPrecisionGrade" :key="item.code" :value="item.code"
                  :selected="item.code === precisionGradeCode"
          >
            {{ item.name }}
          </option>
        </select>
      </label>
    </p> <!-- control (end) -->
    <button class="button" @click="editPrecisionParams">
      <span class="icon">
        <i class="fas fa-sliders-h"></i>
      </span>
    </button>

    </div>
  </div>
</nav>

    <span>
      <p style="text-align:center;margin-top:-10px;margin-bottom:-10px;">
        <span v-if="precisionGradeCode !== -1">
          中误差: {{ precisionParams.m_Sigma }}，定权方式:&nbsp;
          <span v-if="precisionParams.qtype">距离&sup2;</span>
          <span v-else>距离&sup1;</span>
          ，显著水平: {{ precisionParams.alpha }}
        </span>
      </p>
    </span>

  </div> <!-- card-content (end) -->
</div> <!-- card -->

<div class="card">
  <header class="card-header">
    <p class="card-header-title">
      平差计算
    </p>
  </header>
  <div class="card-content">

<nav class="level">
  <div class="level-item has-text-centered">
    <div class="field has-addons">
      <p class="control">
        <button class="button" @click="diniLsAdjustment" :disabled="precisionParamsSet===-1">
          <span class="icon is-small">
            <i class="fas fa-square-root-alt"></i>
          </span>
          <span>{{ report[0].desc }}</span>
        </button>
      </p>
      <p class="control">
        <button class="button"
                @click="view(0)"
                :disabled="!isReportOneGot"
        >
          <span class="icon is-small">
            <i class="fas fa-eye"></i>
          </span>
          <span>查看报告</span>
        </button>
      </p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div class="field has-addons">
      <p class="control">
        <button class="button" @click="diniDataSnooping" :disabled="precisionParamsSet===-1">
          <span class="icon is-small">
            <i class="fas fa-search"></i>
          </span>
          <span>{{ report[1].desc }}</span>
        </button>
      </p>
      <p class="control">
        <button class="button"
                @click="view(1)"
                :disabled="!isReportTwoGot"
        >
          <span class="icon is-small">
            <i class="fas fa-eye"></i>
          </span>
          <span>查看报告</span>
        </button>
      </p>
    </div>
  </div>
</nav>

  </div> <!-- card-content (end) -->
</div> <!-- card (end) -->
</div>

<div class="modal" :class="{ 'is-active': isShowModalReport }">
  <div class="modal-background" @click="isShowModalReport = false"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ reportShown.desc }}报告</p>
      <button class="delete" aria-label="close" @click="isShowModalReport = false"></button>
    </header>
    <section class="modal-card-body">
      <div class="no-break">
        {{ reportShown.content }}
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-success" @click="download(reportShown.type)">下载报告</button>
      <button class="button" @click="isShowModalReport = false">返回</button>
    </footer>
  </div>
</div>

<div class="modal" :class="{ 'is-active': isShowModalEdit}">
  <div class="modal-background" @click="cancelEdit"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">修改</p>
      <button class="delete" aria-label="close" @click="cancelEdit"></button>
    </header>
    <section class="modal-card-body">
      <div>
        <div class="field">
          <label class="label">测站编号</label>
          <div class="control">
            <input class="input" type="text" v-model="editPoint.updated.name">
          </div>
        </div>
        <div class="field">
          <label class="label">高程</label>
          <div class="control">
            <input class="input" type="number" v-model.number="editPoint.updated.h">
          </div>
        </div>
        <div class="control">
          <label class="label">已知点</label>
          <label class="select">
            <select v-model.number="editPoint.updated.isVKnown">
              <option value=-1>否</option>
              <option value=1>是</option>
            </select>
          </label>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-success" @click="saveEdit(editPoint)">确定</button>
      <button class="button" @click="cancelEdit">取消</button>
    </footer>
  </div>
</div>

<div class="modal" :class="{ 'is-active': isShowModalPrecision}">
  <div class="modal-background" @click="isShowModalPrecision = false"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">自定义精度指标</p>
      <button class="delete" aria-label="close" @click="isShowModalPrecision = false"></button>
    </header>
    <section class="modal-card-body">
      <div>
        <div class="field">
          <label class="label">高差观测值验前中误差</label>
          <div class="field has-addons">
            <div class="control" style="width:100%;">
              <input class="input" type="number" v-model="tmpPrecisionParams.m_Sigma">
            </div>
            <div class="control" style="width:auto;">
              <span class="button is-static"><span style="color:black;">米</span></span>
            </div>
          </div>
        </div>
        <div class="field">
          <label class="label">定权方式</label>
          <div class="control">
            <label class="radio">
              <input type="radio"
                     :checked="!tmpPrecisionParams.qtype"
                     @click="tmpPrecisionParams.qtype = false"
              >距离&sup1;
            </label>
            <label class="radio">
              <input type="radio"
                     :checked="tmpPrecisionParams.qtype"
                     @click="tmpPrecisionParams.qtype = true"
              >距离&sup2;
            </label>
          </div>
        </div>
        <div class="field">
          <label class="label">显著水平</label>
          <div class="control">
            <input class="input" type="number" v-model.number="tmpPrecisionParams.alpha">
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-success" @click="savePrecisionParams">确定</button>
      <button class="button" @click="isShowModalPrecision = false">取消</button>
    </footer>
  </div>
</div>

<div class="modal" :class="{ 'is-active': isShowModalWaiting }">
  <div class="modal-background"></div>
  <div class="modal-card">
    <section class="modal-card-body">
      <div style="text-align: center;">
        <button class="button is-white is-large is-loading">Loading</button>
      </div>
    </section>
  </div>
</div>
<div class="modal" :class="{ 'is-active': isShowModalMessage}">
  <div class="modal-background" @click="isShowModalMessage = false"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">注意</p>
      <button class="delete" aria-label="close" @click="isShowModalMessage = false"></button>
    </header>
    <section class="modal-card-body">
      {{ showMessage }}
    </section>
    <footer class="modal-card-foot">
      <button class="button" @click="isShowModalMessage = false">返回</button>
    </footer>
  </div>
</div>

</div>
</template>

<script>
import Vue from 'vue'
import { TableFields, updateRowsPoint, updateRowsDetaH, setPrecisionParams, base64e, base64d, matchUA } from '@/utils'
import DOWNLOAD_API from '@/api'

export default {
  data () {
    return {
      sessionId: '',
      // files: [],
      fileList: {
        fileList1: []
      },
      uploadNumber: 1,
      isShowModalWaiting: false,
      isShowModalMessage: false,
      isShowModalEdit: false,
      isShowModalReport: false,
      isShowModalPrecision: false,
      showMessage: '',
      isShowPanel: false,
      panelTabIndex: 1,
      columnsDetaH: TableFields.detaH,
      rowsDetaH: [],
      columnsPoint: TableFields.surveyPoint,
      rowsPoint: [],
      editPoint: {
        pristine: { name: '', h: 0.0, isVKnown: -1 },
        updated: { name: '', h: 0.0, isVKnown: -1 }
      },
      report: [
        {
          type: 0,
          desc: '经典平差',
          content: ''
        },
        {
          type: 1,
          desc: '粗差探测',
          content: ''
        }
      ],
      reportShown: {},
      itemsPrecisionGrade: [
        { code: '1', name: '一等' },
        { code: '2', name: '二等' },
        { code: '3', name: '三等' },
        { code: '4', name: '四等' },
        { code: '0', name: '自定义' }
      ],
      precisionGradeCode: -1,
      precisionParams: {},
      tmpPrecisionParams: {}
    }
  },
  methods: {
    previewFile (listKey, event) {
      var allowedExtensions = /(\.dat)$/i
      this.fileList[listKey] = []
      for (var i = 0, len = event.target.files.length; i < len; i++) {
        var item = event.target.files[i]
        if (!allowedExtensions.exec(item.name)) {
          this.isShowPanel = false
          this.rowsDetaH = []
          this.rowsPoint = []
          this.isShowModalMessage = true
          this.showMessage = '无效的数据格式！请重新选择。'
          return false
        }
        this.fileList[listKey].push(item)
      }
    },
    submitDiniDat (evt) {
      this.isShowModalWaiting = true
      var formData = new FormData()
      let keys = Object.keys(this.fileList)
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i]
        for (let j = 0; j < this.fileList[key].length; j++) {
          formData.append(
            'files',
            this.fileList[key][j],
            this.fileList[key][j].name
          )
        }
      }

      this.$store.dispatch('submitLevelData2', formData)
        .then(res => {
          // console.log(res)
          this.isShowModalWaiting = false
          this.rowsDetaH = res.data.result.detaHList
          this.rowsPoint = res.data.result.pointsList
          this.sessionId = res.data.sessionId
          this.isShowPanel = true
        }).catch(error => {
          console.log({'Error Posting': error})
          this.isShowModalWaiting = false
          this.showMessage = '出现了一个错误'
          // TODO: if
          if (error.response.status === 403) {
            this.showMessage += ': missing openid'
          }
          this.isShowModalMessage = true
        })
    },
    rowClick (value) {
      // console.log(value)precisionParams
      var pristinePoint = { name: value.pointname, h: value.h, isVKnown: value.isVKnown }
      this.editPoint = { pristine: pristinePoint, updated: Object.assign({}, pristinePoint) }
      this.isShowModalEdit = true
    },
    tabClick (index) {
      this.panelTabIndex = index
    },
    cancelEdit () {
      this.isShowModalEdit = false
    },
    saveEdit (value) {
      // console.log(value)
      var updatePoint = updateRowsPoint(this.rowsPoint, value)
      var updateDetaH = updateRowsDetaH(this.rowsDetaH, value)
      Vue.set(this.rowsPoint, updatePoint.index, updatePoint.value)
      if (updateDetaH.indexs[0] !== -1) {
        Vue.set(this.rowsDetaH, updateDetaH.indexs[0], updateDetaH.values[0])
      }
      if (updateDetaH.indexs[1] !== -1) {
        Vue.set(this.rowsDetaH, updateDetaH.indexs[1], updateDetaH.values[1])
      }
      this.isShowModalEdit = false
    },
    onPrecisionGradeChanged () {
      if (this.precisionGradeCode === 0) {
        this.editPrecisionParams()
        // 恢复 precisionGradeCode 的值到之前的设定, 在 save 之前
        switch (this.precisionParams.m_Sigma) {
          case 0.001:
            this.precisionGradeCode = 1
            break
          case 0.002:
            this.precisionGradeCode = 2
            break
          case 0.006:
            this.precisionGradeCode = 3
            break
          case 0.01:
            this.precisionGradeCode = 4
            break
        }
      } else {
        this.precisionParams = Object.assign({}, setPrecisionParams(this.precisionGradeCode))
      }
    },
    editPrecisionParams () {
      this.tmpPrecisionParams = Object.assign({}, this.precisionParams)
      this.isShowModalPrecision = true
    },
    savePrecisionParams () {
      Vue.set(this.precisionParams, 'm_Sigma', this.tmpPrecisionParams.m_Sigma)
      Vue.set(this.precisionParams, 'qtype', this.tmpPrecisionParams.qtype)
      Vue.set(this.precisionParams, 'alpha', this.tmpPrecisionParams.alpha)
      this.precisionGradeCode = 0

      this.isShowModalPrecision = false
    },
    diniLsAdjustment () {
      this.isShowModalWaiting = true
      var payload = {
        'tmPrecision': this.precisionParams,
        'detaHList': this.rowsDetaH,
        'pointsList': this.rowsPoint
      }
      this.$store.dispatch('diniLsAdjustment', payload)
        .then(res => {
          this.isShowModalWaiting = false
          this.report[0].content = res.data
        })
    },
    diniDataSnooping () {
      this.isShowModalWaiting = true
      var payload = {
        'tmPrecision': this.precisionParams,
        'detaHList': this.rowsDetaH,
        'pointsList': this.rowsPoint
      }
      this.$store.dispatch('diniDataSnooping', payload)
        .then(res => {
          this.isShowModalWaiting = false
          this.report[1].content = base64d(res.data)
        })
    },
    view (value) {
      this.reportShown = this.report[value]
      this.isShowModalReport = true
    },
    download (value) {
      // 这里之所以直接使用 "xxxx报告.txt" 而不是文件名作为名字是因为有可能上传多个文件
      if (value === 0) {
        this.reportDownload(this.report[value].content, '经典平差报告' + '.txt')
      } else if (value === 1) {
        this.reportDownload(this.report[value].content, '粗差探测报告' + '.txt')
      }
    },
    reportDownload (data, name) {
      var ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) !== null) {
        if (ua.match(/WindowsWechat/i) !== null) {
          // alert('桌面微信浏览器')
          this.createElt2Download(data, name)
        } else {
          // alert('微信浏览器')
          var payload = {'sessionId': this.sessionId, 'base64Str': base64e(data), 'name': name, 'ua': ua}
          this.$store.dispatch('postData4Download', payload)
            .then(response => {
              const elt = document.createElement('a')
              elt.href = DOWNLOAD_API + response.data.filename
              document.body.appendChild(elt)
              elt.click()
              document.body.removeChild(elt)
            })
        }
      } else {
        // alert('不是微信浏览器')
        this.createElt2Download(data, name)
      }
    },
    createElt2Download (data, name) {
      const element = document.createElement('a')
      element.setAttribute('href', 'data:application/octet-stream;charset=utf-8,' + encodeURIComponent(data))
      element.setAttribute('download', name)
      element.style.display = 'none'
      element.click()
    },
    changeUploadNumber (isPlus) {
      // var step = isPlus ? 1 : -1
      // this.uploadNumber += step
      if (isPlus) {
        this.uploadNumber += 1
        // this.fileList['fileList' + this.uploadNumber] = []
        Vue.set(this.fileList, 'fileList' + this.uploadNumber, [])
      } else {
        delete this.fileList['fileList' + this.uploadNumber]
        this.uploadNumber -= 1
      }
    }
  },
  computed: {
    isFillComplete () {
      // if (this.files.length === 0) {
      //   return false
      // }
      for (let i = 0; i < Object.keys(this.fileList).length; i++) {
        if (this.fileList['fileList' + (i + 1)].length !== 0) {
          return true
        }
      }
      return false
    },
    isReportOneGot () {
      return this.report[0].content !== ''
    },
    isReportTwoGot () {
      return this.report[1].content !== ''
    },
    precisionParamsSet () {
      return this.precisionGradeCode
    },
    isWxAndroidClient () {
      // return matchUA('Android')
      return matchUA('micromessenger') && (matchUA('Android') || matchUA('iPhone'))
    }
  }
}
</script>

<style>
button.card-footer-item {
  background-color: transparent;
  cursor: pointer;
  color: link;
  border: 0;
  font-size: 1rem;
  line-height: 1.5;
}
p.addition-text {
  margin-top: 10px;
}
.overflow-hidden {
  overflow: hidden;
}
nav.panel {
  margin: 1em;
}
.center {
  margin-left: auto;
  margin-right: auto;
}
div.no-break {
  white-space: pre;
  font-family: monospace;
}
</style>



// WEBPACK FOOTER //
// src/components/FeatureTwo.vue